import { hasQualifiedStatus } from '@common/order/helperFunctions';
import { Notification } from '@components';
import { FeatureFlags } from '@constants/featureFlags';
import { isFeatureFlagEnabled } from '@store/featureFlags/store';
import {
  isCreditLimitExceeded,
  orderContainsLTLLoad,
  orderStore,
} from '@store/orders';
import { ILoadEditViewModel } from '@typeDefinitions/loadTypes';
import { CarrierInstructions, Stops, Tracking } from '@views/order/components';
import { Show } from 'solid-js';

import Claim from '../../claim/Claim';
import { CarrierOffers } from '../../offers/CarrierOffers';
import SendEDIUpdate from '../../sendEdiUpdate/SendEDIUpdate';
import { LoadInfo } from '../LoadInformation';
import { MatchedBanner } from '../MatchedBanner';

type Props = {
  load: ILoadEditViewModel;
  index: number;
  edi: boolean;
  show214: boolean;
};

export const Layout = (props: Props) => {
  return (
    <>
      <Show
        when={
          isFeatureFlagEnabled(
            FeatureFlags.feature_order_block_save_on_neg_credit_limit,
          )() &&
          !orderStore.isCreate &&
          isCreditLimitExceeded() &&
          !orderContainsLTLLoad() &&
          hasQualifiedStatus(
            orderStore.order.loads[orderStore.activeTab.index].status,
          ) &&
          !!orderStore.order.loads[orderStore.activeTab.index].carrierId
        }
      >
        <Notification
          type="error"
          text="Load cannot be saved with a carrier assigned due to exceeded customer credit limit."
          cleared={false}
        />
      </Show>
      <Show when={orderStore.matched} fallback={<></>}>
        <MatchedBanner />
      </Show>
      {props.load.claim !== null && <Claim load={props.load} />}
      <LoadInfo />
      <CarrierOffers />
      <CarrierInstructions load={props.load} tabIndex={props.index} />
      <Stops tabIndex={props.index} load={props.load} />
      <Show when={props.load.id > 0 && props.edi && props.show214}>
        <SendEDIUpdate load={props.load} index={props.index} />
      </Show>
      <Tracking />
    </>
  );
};
